import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'syngenta-digital-cropwise-react-ui-kit';
import { SubmissionStatus } from 'screens/Integrations/helpers/constants';
import { Popup } from '@agconnections/grow-ui';
import { taskFormat } from '../../../../../helpers/dateFormat';

const STATUS_CONFIG = {
  [SubmissionStatus.DONE]: { label: 'SUBMITTED', color: 'green' },
  [SubmissionStatus.ERROR]: { label: 'ERROR', color: 'red' },
  complete: { label: 'COMPLETE', color: 'green' },
  need_info: { label: 'NEEDS INFO', color: 'yellow' },
  duplicated: { label: 'DUPLICATED', color: 'neutral' }
};

const CalAgAccordionHeader = ({
  firstLabel = 'NOT_DEFINED_FIRST_LABEL',
  secondLabel = 'NOT_DEFINED_SECOND_LABEL',
  status = 'NOT_DEFINED_STATUS',
  isTagVisible = true,
  pastSubmission = null,
  duplicationError = false
}) => {
  const label = duplicationError
    ? STATUS_CONFIG.duplicated.label
    : STATUS_CONFIG[status].label;
  const color = duplicationError
    ? STATUS_CONFIG.duplicated.color
    : STATUS_CONFIG[status].color;

  const TagPreviouslySubmitted = (
    <div className="ml-6">
      <Tag
        key="field-past-submission"
        color="neutral"
        data-testid="field-past-submission"
      >
        Previously Submitted
      </Tag>
    </div>
  );
  return (
    <div className="m-4 flex flex-row w-full justify-start">
      {isTagVisible && (
        <span className="text-yellow-700">
          <Tag key="field-status" color={color} data-testid="status-tag">
            {label}
          </Tag>
        </span>
      )}
      <span className="ml-2 " data-testid="farm-name">
        {firstLabel}
      </span>
      <span className="ml-2 font-bold" data-testid="farm-name">
        / {secondLabel}
      </span>
      {pastSubmission && (
        <Popup
          enableHover
          position="top"
          align="center"
          hasArrow
          bgColor="#232630"
          trigger={TagPreviouslySubmitted}
        >
          <div
            className="gr-w-48 text-xs text-white text-left"
            data-testid="previously-submitted-hover-content"
          >
            This record was last submitted on{' '}
            {taskFormat(pastSubmission.submittedAt)} with Document Number{' '}
            {pastSubmission.internalRecordId}
          </div>
        </Popup>
      )}
    </div>
  );
};

CalAgAccordionHeader.propTypes = {
  firstLabel: PropTypes.string,
  secondLabel: PropTypes.string,
  status: PropTypes.string,
  isTagVisible: PropTypes.bool,
  duplicationError: PropTypes.bool,
  pastSubmission: PropTypes.shape({
    submissionId: PropTypes.string,
    submittedAt: PropTypes.string,
    internalRecordId: PropTypes.string
  })
};

export default CalAgAccordionHeader;
